import {useSalesMarketingApi} from "./useSalesMarketingApi";
import qs from "qs";
import dayjs from "dayjs";

export const useBusinessAgreementActions = () => {
    const {GET, POST, PUT} = useSalesMarketingApi();

    async function getBusinessAgreementList(filters: any) {
        let params = {
            tenantId: filters.legalEntity ? filters.legalEntity : undefined,
            dealerId: filters.dealer ? filters.dealer : undefined,
            businessConventionCode: filters.businessCode ? filters.businessCode : undefined,
            name: filters.name ? filters.name : undefined,
            description: filters.description ? filters.description : undefined,
            status: filters.status ? filters.status : undefined,
            customerId: filters.customerId ? filters.customerId : undefined,
            customerName: filters.customerName ? filters.customerName : undefined,
            personName: filters.personName ? filters.personName : undefined,
            personSurname: filters.personSurname ? filters.personSurname : undefined,
            segmentCode: filters.segment ? filters.segment : undefined,
            startDate: filters.startDate ? dayjs(filters.startDate).utcOffset(0).startOf("day").toISOString() : undefined,
            endDate: filters.endDate ? dayjs(filters.endDate).utcOffset(0).endOf("day").toISOString() : undefined,
            cig: filters.cig ? filters.cig : undefined,
            search: filters.search ? filters.search : undefined,
            offset: filters.offset,
            limit: filters.limit,
            sort: filters.sort ? filters.sort : undefined,
            order: filters.order ? filters.order : undefined
        };
        let data = await GET("sm/business-convention", true, {
            params: params,
            paramsSerializer: (params: any) => qs.stringify(params, {arrayFormat: 'repeat', skipNulls: true})
        });
        return {
            totalElements: data?.result?.totalElements,
            content: data?.result?.content
        };
    }

    async function getBusinessAgreementById(id: any) {
        let data = await GET("sm/business-convention/" + id, true);
        return data?.result;
    }

    async function createBusinessAgreement(payload: any) {

        return await POST("sm/business-convention/", payload, true)
    }

    async function updateBusinessAgreement(payload: any) {

        return await PUT("sm/business-convention/", payload, true)
    }


    return {
        getBusinessAgreementList,
        getBusinessAgreementById,
        createBusinessAgreement,
        updateBusinessAgreement
    };
}